
import { Component, Vue, Watch } from 'vue-property-decorator'
import { TransTopReq, GetAllGameList } from '@/api/admin/risk'
@Component
export default class userRiskInfo extends Vue {
  select = {
    type_List: [
      { value: 0, name: 'IP黑名单' },
      { value: 1, name: 'Mac地址' }
    ]
  }
  //表单数据
  table = {
    params: {
      mod: 'root',
      platid: 0,
      app_id: 0,
      param: {
        _mod: 'root',
        _func: 'SearchUserRiskInfo',
        _param: { val: '', ctype: undefined, app_id: 0 }
      }
    },
    data: [],
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      {
        title: '所属分组',
        key: 'platid',
        minWidth: 100,
        align: 'center',
        render: (h, params) => {
          let app_info: any = this.getPlatInfo(params.row)
          return h('div', [
            h('span', app_info.name || ''),
            h('span', { style: 'color:#bbb;' }, `（${app_info.id || ''}）`)
          ])
        }
      },
      {
        title: '盘口信息',
        key: 'app_id',
        minWidth: 100,
        align: 'center',
        render: (h, params) => {
          let app_info: any = this.getAppInfo(params.row)
          return h('div', [
            h('span', app_info.appName || ''),
            h('span', { style: 'color:#bbb;' }, `（${app_info.appid || ''}）`)
          ])
        }
      },
      { key: 'uid', title: '玩家ID', align: 'center', minWidth: 70 }
    ]
  }
  getAppInfo(el: any) {
    return (
      (this as any).app_list.find((item: any) => item.appid == el.app_id) || {}
    )
  }
  getPlatInfo(el: any) {
    return (
      (this as any).plat_list.find((item: any) => item.id == el.platid) || []
    )
  }
  //获取列表
  getUserRiskList(num?) {
    this.table.params.param._param.app_id = this.table.params.app_id
    let param = this.table.params
    TransTopReq(param).then(res => {
      this.table.data = res['_param'].data || []
    })
  }
  initFunc() {
    this.table.params.platid = (this as any).getinitPlatId()
    // this.table.params.app_id = (this as any).app_list.find(
    //   item => item.platform == this.table.params.platid
    // ).appid
  }
  created() {
    this.initFunc()
    // this.getAllGameList();
  }
}
